import { render, staticRenderFns } from "./alert-details.vue?vue&type=template&id=61d4a6c9&scoped=true"
import script from "./alert-details.vue?vue&type=script&lang=js"
export * from "./alert-details.vue?vue&type=script&lang=js"
import style0 from "./alert-details.vue?vue&type=style&index=0&id=61d4a6c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4a6c9",
  null
  
)

export default component.exports